/**
 * «Телефон» новой темы: разметка прежнего поля (общий LegacyInput), правило
 * ввода и проверки — из phone-rule.ts. Значение для отправки — как у
 * прежнего поля: номер, который libphonenumber признаёт верным, приводится к
 * международному виду (+7…); любой другой уходит так, как его ввёл гость.
 */
import { LegacyInput, InputRef } from '@/components/input'
import { Ref, forwardRef, useEffect, RefObject } from 'react'
import { uiEvents } from '@/utils/event'
import { useVenueContext } from '@/services/venue'
import { CountryCode } from 'libphonenumber-js/types'
import { useAppContext } from '@/pages/_app'
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'
import { INPUT_PHONE_KEY, INPUT_PHONE_STORAGE } from '@/components/input-phone-storage'
import { isPhoneLike, keepPhoneChars, useRejectNonPhoneChars } from '@/modern/phone-rule'

export type InputPhoneProps = {
  label: string
  required?: boolean
}
export const InputPhone = forwardRef(InputPhoneWithRef)
function InputPhoneWithRef(props: InputPhoneProps, ref: Ref<InputRef>) {
  const { t } = useAppContext()
  const { venue } = useVenueContext()!
  useRejectNonPhoneChars()

  useEffect(() => {
    const input = (ref as RefObject<InputRef>)?.current
    if (input && input.value.length > 0) {
      input?.touch()
    }
  }, [])

  const venueCountryCode = venue.country.toUpperCase() as CountryCode
  const phoneToSend = (input: string) => {
    const countryCode = input.trim().startsWith('+') ? undefined : venueCountryCode
    const phoneNumber = parsePhoneNumberFromString(input, countryCode)
    return phoneNumber && phoneNumber.isValid() ? phoneNumber.number : input.trim()
  }

  return (
    <LegacyInput
      ref={ref}
      schemaVersion={2}
      id={INPUT_PHONE_KEY}
      label={props.label}
      storage={INPUT_PHONE_STORAGE}
      type="tel"
      value=""
      required={!!props.required}
      validateOn="blur"
      validate={(input) => {
        if (input.length > 0 && !isPhoneLike(input)) {
          return [t('inputPhone:enterPhone')]
        }

        return []
      }}
      onChange={(input) => {
        const newValue = keepPhoneChars(input)
        uiEvents.next({
          type: 'InputPhoneChanged',
          newValue,
        })
        return [newValue, phoneToSend(newValue)]
      }}
    />
  )
}
